import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

const CryptoJS = require('crypto-js');
/* eslint-disable */
const member_api = 'emc-api-server.eilis-ai.com';

// AES 加解密
const aeskey = 'FFzqekWVwgu7Oz28pfyPUlbOk4UusnNc';
const aesiv  = '2uY28N7v5kVEuFPr';
const keystr = CryptoJS.enc.Utf8.parse(aeskey);
const ivstr  = CryptoJS.enc.Utf8.parse(aesiv);

const options = {
    iv: ivstr,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
};


function aesEncrypt(data) {
    const content = JSON.stringify(data);
    const signature = CryptoJS.AES.encrypt(content, keystr, options).toString();
    return signature;
}


Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        uid: '',
        pageDetail: null,
        accountDetail: null,
        userName: 'Ryan',
        successMsg: '',
        comsumeMsg: '',
        exchangeMsg: '',
        userpoints: '--',
        userItemCount: {},
        undoMsg: '',
        lastLogin: '',
        consumeList: [],
        consumeList2: [],
        exchangeList: [],
        sendList: [],
        storeList: [],
        displayName: '無資料',
        userid: '無資料'
    },
    getters: {
        lastlogin    : state => state.lastLogin,
        successMsg   : state => state.successMsg,
        comsumeMsg   : state => state.comsumeMsg,
        exchangeMsg  : state => state.exchangeMsg,
        pageDetail   : state => state.pageDetail,
        userpoints   : state => state.userpoints,
        userItemCount: state => state.userItemCount,
        undoMsg      : state => state.undoMsg,
        userid       : state => state.uid,
        username     : state => state.userName,
        displayName  : state => state.displayName,
        userid       : state => state.userid,
        consumeList  : state => state.consumeList,
        consumeList2 : state => state.consumeList2,
        sendList     : state => state.sendList,
        storeList    : state => state.storeList,
        exchangeList : state => state.exchangeList,
        accountDetail: state => state.accountDetail
    },
    mutations: {
        getUser(state, payload) {
            state.uid = payload.uid;
            state.userName = payload.displayName;
            state.lastLogin = payload.lastLoginAt;
        },
        getConsume(state, payload) {
            state.consumeList = payload.reverse();
        },
        getPoints(state, payload) {
            state.userpoints = payload;
        },
        getConsume2(state, payload) {
            state.consumeList2 = payload.reverse();
        },
        getUserItem(state, payload) {
            state.userItemCount = payload;
        },
        getExchange(state, payload) {
            state.exchangeList = payload.reverse();
        },
        getStoreList(state, payload) {
            state.storeList = payload;
        },
        setSuccessMsg(state, payload) {
            state.successMsg = payload;
        },
        getUserPro(state, user) {
            state.displayName = user.displayName
            state.userid = user.userid
        },
        getSendList(state, payload) {
            state.sendList = payload;
        },
        setAccountDetail(state, payload) {
            state.accountDetail = payload;
        },
        setPageDetail(state, payload) {
            state.pageDetail = payload;
        }
    },
    actions: {
        // 取得 AES 加密字串
        getEncryptCode({ commit, state }, payload) {
            const aescode = aesEncrypt(payload);
            localStorage.setItem('aescode', aescode);
        },
        getDecryptData({ commit, state }, payload) {
            const originalText = CryptoJS.AES.decrypt(payload, keystr, options).toString(CryptoJS.enc.Utf8);
            commit('setPageDetail', JSON.parse(originalText));
        },
        // 用 liff 取得 id
        getUserID({ commit, state }, payload) {
        },
        // 註冊臉書
        createUserFB({ commit, state }, contents) {
            const apiUrl = `https://${member_api}/register`;
            return axios.post(apiUrl, contents)
                .then((res) => {
                    return res;
                });
        },
        // 註冊LINE
        createUserLINE({ commit, state }, contents) {
            const apiUrl = `https://${member_api}/register`;
            return axios.post(apiUrl, contents)
                .then((res) => {
                    return res;
                });
        },
        getAESData({}, contents) {
            const apiUrl = `https://emc-api-server.eilis-ai.com/api/${contents.auth}/v1/getAESData`;
            const postData = {
                content: contents.content.replace(/%2B/g, '+').replace(/%2F/g, '/').replace(/%3D/g, '=')
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                })
        },
        sendSMS({ commit, state }, contents) {
            const apiUrl = 'https://louisa-api-server.eilis-ai.com/sendSMS'
            const data   = {
                phone: contents.phone, // 起始交易日期
                message: (contents.countryCode === '886') ? `你的驗證碼為: ${contents.code} (Powered by EILIS)` : `Your verification code: ${contents.code} (Powered by EILIS)`,
                service: contents.service,
                auth: contents.auth,
                countryCode: contents.countryCode
            };
            return axios.post(apiUrl, data)
                .then((res) => {
                    return res;
                })
        },
        // 查看電話是否註冊
        checkIsRegister({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkPhone`;
            const data   = {
                service: payload.service,
                auth: payload.auth,
                token: payload.token,
                phone: payload.phone
            };
            return axios.post(apiUrl, data)
                .then((res) => {
                    return res;
                })
        },
        // 檢查電話
        checkPhoneUser({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getUserAccount`;
            const trimPhone = payload.phone.trim();
            const validphone = trimPhone[0] === '0' ? trimPhone : `0${trimPhone}`;
            return axios.post(apiUrl, { Phone: validphone })
                .then((res) => {
                    return res.data;
                })
        },
        // 檢查是否有開通會員
        checkAccount({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkAccount`;
            const postData = {
                Service: payload.Service,
                Auth: payload.Auth
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    commit('setAccountDetail', res.data.Detail);
                    return res.data.Detail;
                });
        },
        // 檢查FB用戶
        checkUserFB({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkExist`;
            const postData = {
                PageID: payload.PageID,
                PSID: payload.PSID,
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data && res.data.Detail) {
                        const point = res.data.Detail.Points ? parseInt(res.data.Detail.Points) : 0
                        commit('getPoints', point);
                    }
                    return res;
                });
        },
        sendLoginRecom({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/loginRecom`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                receivedPhone: payload.receivedPhone,
                recomPhone: payload.recomPhone,
                loginRecom: payload.loginRecom
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 晚點處理
        checkRecomPhone({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkRecomPhone`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                receivedPhone: payload.receivedPhone,
                recomPhone: payload.recomPhone,
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        addUserTag({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/createTag`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                UserPhone: payload.phone,
                Tag: payload.tag,
                BindServ: payload.bindServ
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        checkLoginStatus({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkLogin`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Phone: payload.phone
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        userFirstLogin({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/welcomeMsg`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Phone: payload.phone
            };
            axios.post(apiUrl, postData);
        },
        userLoginGift({ commit, state }, payload) {
            const apiUrl = `https:/${member_api}/loginGift`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Phone: payload.phone
            };
            axios.post(apiUrl, postData);
        },
        setHistory({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/addHistory`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Key: payload.key,
                Store: payload.store,
                Type: payload.type,
                StoreDetail: payload.storedetail,
                UserDetail: payload.userdetail
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 檢查LINE用戶
        checkUserLINE({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkLine`;
            const postData = {
                ChannelID: payload.ChannelID,
                UserID: payload.UserID
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data && res.data.Detail) {
                      const point = res.data.Detail.Points ? res.data.Detail.Points : 0
                      commit('getPoints', point);  
                    }
                    return res;
                });
        },
        GetBasicID({ commit, state }, payload) {
            const apiUrl = 'https://tc-line-bot-test.herokuapp.com/app/GetBasicID';
            const postData = {
                ChannelID: payload.channelID
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 查詢用戶點數
        getPoints({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getUserData`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Phone: payload.phone
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data;
                });
        },
        // 查詢用戶資料
        getUserByPhone({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/getUserByPhone';
            const postData = {
                service: payload.service,
                auth: payload.auth,
                phone: payload.phone
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data;
                });
        },
        // 更換電話驗證狀態
        changeUserPhone({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/changeUserPhone`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        // 加值點數
        refreshPointBeta({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/comsumeBeta';
            const postData = {
                Phone: payload.phone,
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.points,
                Price: payload.price,
                Store: payload.store,
                EXP: payload.exp
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 加值點數
        refreshPoint({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/comsumeBeta';
            const postData = {
                Phone: payload.phone,
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.points,
                Price: payload.price,
                Store: payload.store
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 登入表單
        sendSheet({ commit, state }, payload) {
            const apiUrl = 'https://member-card.herokuapp.com/loginHistory';
            const postData = {
                PageID: payload.auth,
                Channel: payload.service
            };
            axios.post(apiUrl, postData);
        },
        comsumeBroadcast({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/comsumeBroadcast`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        // 傳送訊息
        sendResponseMsgBeta({ commit, state }, payload) {
            const apiUrl = 'https://api-eilis-server-v2.herokuapp.com/functional/comsumeBroadcastBeta';
            const postData = {
                PageID: payload.auth,
                PSID: payload.token,
                Message: payload.message,
                
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 傳送成功訊息
        sendResponseMsg({ commit, state }, payload) {
            const apiUrl = 'https://api-eilis-server-v2.herokuapp.com/functional/comsumeBroadcast';
            const postData = {
                PageID: payload.auth,
                PSID: payload.token,
                Points: payload.points
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        sendResponseLINEBeta({ commit, state }, payload) {
            const apiUrl = 'https://api-linebiz.eilis-ai.com/app/ConsumptionNoticeBeta';
            const postData = {
                ChannelID: payload.auth,
                UserID: [payload.token],
                Message: payload.message
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        sendResponseLINE({ commit, state }, payload) {
            const apiUrl = 'https://api-linebiz.eilis-ai.com/app/ConsumptionNotice';
            const postData = {
                ChannelID: payload.auth,
                UserID: [payload.token],
                Point: payload.points
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        recalculateShopItemNum({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/recalculateShopItemNum`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        undoEventBooking({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/undoBooking`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                eventId: payload.eventId,
                token: payload.token
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                })
        },
        getExchange({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getExchangeDetail`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token
            };
            axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data.List) {
                        commit('getExchange', Object.values(res.data.List));
                    } else {
                        commit('getExchange', []);
                    }
                })
        },
        // 取得串接
        getShopLink({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/api/getShop`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        // 取得訂單頁面
        getOrderLink({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/api/getOrder`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        // 串接客戶會員
        sendMemberAPI({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/api/sendMember`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        // 查詢消費記錄
        getDetail({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getConsumeDetail`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token
            };
            axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data.List) {
                        commit('getConsume', Object.values(res.data.List));
                        commit('getConsume2', Object.values(res.data.List))
                    } else {
                        commit('getConsume', []);
                        commit('getConsume2', []);
                    }
                });
        },
        // 查詢贈點紀錄
        getSend({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSendDetail`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token
            };
            axios.post(apiUrl, postData)
                .then((res) => {
                    if (res.data.List) {
                        commit('getSendList', Object.values(res.data.List));
                    } else {
                        commit('getSendList', []);
                    }
                })
        },
        getSendMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Send'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            })
        },
        getUnExchange({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'UnExchange'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        getAllHistory({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getAllHistory`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Store: payload.store,
                Path: payload.path
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.List;
            });
        },
        getRefundMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Refund'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        getUndoMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Undo'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        getStoreData({ commit, state}, payload) {
            const apiUrl = `https://${member_api}/getStoreList`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth
            };
            return axios.post(apiUrl, postData).then((res) => {
                if (res.data.Store) {
                    commit('getStoreList', res.data.Store);
                }
                return res;
            });
        },
        checkBindAcc({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkBindingAcc`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data;
            });
        },
        checkBindUser({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/checkisBindingUser`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                phone: payload.phone
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data;
            });
        },
        fastLogin({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/fastClearance`;
            const postData = {
                service: payload.service,
                auth: payload.auth,
                token: payload.token,
                userData: payload.userData
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data;
            });
        },
        getExchangeMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Exchange'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        getComsumeMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: 'Comsume'
            };
            return axios.post(apiUrl, postData).then((res) => {
                return res.data.Message;
            });
        },
        setSuccessMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/setSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: payload.type,
                Message: payload.msg
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 查詢成功訊息
        getSuccessMessage({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/getSuccessMessage`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Type: payload.type
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res.data.Message;
                });
        },
        // 兌換點數
        exchangePointBeta({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/exchangeBeta`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.point,
                Store: payload.store
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        // 兌換點數
        exchangePoint({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/exchangeBeta`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.point,
                Store: payload.store
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        reverseComsume({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/exchangeBeta`;
            const postData = {
                Service: payload.service,
                Auth: payload.auth,
                Token: payload.token,
                Points: payload.point,
                Store: payload.store,
                Undo: 'true',
                UndoType: payload.undoType,
                Employee: payload.employee,
                Key: payload.key
            };
            return axios.post(apiUrl, postData)
                .then((res) => {
                    return res;
                });
        },
        updateInfo({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/updateInfo`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        updateUser({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/updateUser`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        sendBookEvent({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/bookEvent`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        exchangeGiftCode({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/exchangeGiftCode`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        },
        recordLogin({ commit, state }, payload) {
            const apiUrl = `https://${member_api}/api/recordLogin`;
            return axios.post(apiUrl, payload)
                .then((res) => {
                    return res;
                })
        }
    },
});

export default store;